var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button"},[_c('button',{staticClass:"save-btn hover-grow",attrs:{"onmouseup":"this.blur();"},on:{"click":_vm.SaveChanges}},[_vm._v(_vm._s(_vm.btnText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }